import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class PlaceOfsTradeUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.placeOfsTrade(req);
    }
}
export default PlaceOfsTradeUseCase;
